var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"d":"M17 1l-4-1h-1l-1 4v1l2 2c-1 3-3 5-6 6l-2-2H4l-4 1v1l1 4h1c8 0 15-7 15-15V1z","id":"phonePath"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},[React.createElement("rect",{"width":"39.1","height":"39.1","rx":"19.6","fill":"#005A8B","transform":"translate(0 1)","key":0}),React.createElement("g",{"transform":"translate(11 12)","key":1},[React.createElement("mask",{"id":"phoneMask","fill":"#fff","key":0},React.createElement("use",{"xlinkHref":"#phonePath"})),React.createElement("g",{"mask":"url(#phoneMask)","fill":"#FFF","key":1},React.createElement("path",{"d":"M0 0h17v17H0z"}))])])]);
}

Phone.defaultProps = {"viewBox":"0 0 39.38 41"};

module.exports = Phone;

Phone.default = Phone;
